import { useContext } from "react";
import { StatusContext } from "context/StatusProvider";
import { UpgradePanel } from "./UpgradePanel";
import { PiSquaresFour } from "react-icons/pi";
import { AiOutlineUnorderedList } from "react-icons/ai";
import { ProductionTypeDropdown } from "components/common/productionTypeDropdown";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/common/TooltipV3";

export const MainpanelHeader = () => {
  const { title } = useContext(StatusContext);

  return (
    <section>
      <UpgradePanel />
      <div className="flex py-[2em] justify-between items-center">
        <div className="flex">
          <div className="title-1 capitalize mr-3">{title}</div>
        </div>
      </div>
    </section>
  );
};

interface PanelHeaderProps {
  gridView?: boolean;
  setGridView?: (value: boolean) => void;
  onProductionTypeChange?: (value: string) => void;
}

export const PanelHeader: React.FC<PanelHeaderProps> = ({
  gridView,
  setGridView,
  onProductionTypeChange = () => {},
}) => {
  const { title } = useContext(StatusContext);

  return (
    <section>
      <UpgradePanel />
      <div className="flex py-[2em] justify-between items-center">
        <div className="flex">
          <div className="title-1 capitalize mr-3">{title}</div>
        </div>

        {/* PROJECT FILTERS */}
        {(title === "Projects" || title === "Shared" || title === "Archive") && (
          <div className="flex gap-4 items-center text-regular-2">
            <ProductionTypeDropdown onChange={onProductionTypeChange} />
            <Tooltip>
              <TooltipTrigger asChild>
                <button
                  type="button"
                  className="font-bold cursor-pointer"
                  onClick={() => setGridView?.(true)}
                  aria-label="Grid View"
                  aria-pressed={Boolean(gridView)}
                >
                  <PiSquaresFour className={`text-2xl ${gridView ? "text-primary" : ""}`} />
                </button>
              </TooltipTrigger>
              <TooltipContent side="bottom">Grid View</TooltipContent>
            </Tooltip>
            <Tooltip>
              <TooltipTrigger asChild>
                <button
                  type="button"
                  className="font-bold cursor-pointer"
                  onClick={() => setGridView?.(false)}
                  aria-label="List View"
                  aria-pressed={!gridView}
                >
                  <AiOutlineUnorderedList
                    className={`text-2xl ${gridView ? "" : "text-primary"}`}
                  />
                </button>
              </TooltipTrigger>
              <TooltipContent side="bottom">List View</TooltipContent>
            </Tooltip>
          </div>
        )}
      </div>
    </section>
  );
};
